export const getMinutesText = (minutes: number): string => {
	const absoluteMinutes = Math.abs(minutes);
	const lastDigit = absoluteMinutes % 10;
	const lastTwoDigits = absoluteMinutes % 100;

	if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
		return 'minut';
	}

	if (lastDigit === 1) {
		return 'minuta';
	}

	if (lastDigit >= 2 && lastDigit <= 4) {
		return 'minuty';
	}

	return 'minut';
};

export const getDaysText = (days: number): string => {
	const absoluteDays = Math.abs(days);
	const lastDigit = absoluteDays % 10;
	const lastTwoDigits = absoluteDays % 100;

	if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
		return 'dni';
	}

	if (lastDigit === 1) {
		return 'dzień';
	}

	if (lastDigit >= 2 && lastDigit <= 4) {
		return 'dni';
	}

	return 'dni';
};

export const getDifferentDaysText = (days: number): string => {
	const absoluteDays = Math.abs(days);
	const lastDigit = absoluteDays % 10;
	const lastTwoDigits = absoluteDays % 100;

	if (lastDigit === 1 && lastTwoDigits !== 11) {
		return 'różny dzień';
	}

	return 'różne dni';
};

export const formatMinutes = (minutes: number): string => {
	return `${minutes} ${getMinutesText(minutes)}`;
};

export const formatDays = (days: number): string => {
	return `${days} ${getDaysText(days)}`;
};

export const formatDifferentDays = (days: number): string => {
	return `${days} ${getDifferentDaysText(days)}`;
};
